var exports = {
  "tb": "UserProfileModal.module__noteTextarea___NUpVM0",
  "CR": "UserProfileModal.module__modalRoot___NUpVM0",
  "eF": "UserProfileModal.module__userInfo___NUpVM0",
  "hR": "UserProfileModal.module__userInfoHeader___NUpVM0",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___NUpVM0",
  "Rn": "UserProfileModal.module__userInfoContent___NUpVM0",
  "yn": "UserProfileModal.module__profileDataWarning___NUpVM0",
  "S7": "UserProfileModal.module__nameRow___NUpVM0",
  "nT": "UserProfileModal.module__userName___NUpVM0",
  "a1": "UserProfileModal.module__userTag___NUpVM0",
  "Fj": "UserProfileModal.module__usernameRow___NUpVM0",
  "hI": "UserProfileModal.module__pronouns___NUpVM0",
  "sM": "UserProfileModal.module__srOnly___NUpVM0",
  "Li": "UserProfileModal.module__customStatusText___NUpVM0",
  "Ef": "UserProfileModal.module__customStatusRow___NUpVM0",
  "_z": "UserProfileModal.module__tagBadgeRow___NUpVM0",
  "U3": "UserProfileModal.module__badgesWrapper___NUpVM0",
  "ZV": "UserProfileModal.module__userNoteEditor___NUpVM0",
  "xu": "UserProfileModal.module__noteLabel___NUpVM0",
  "_j": "UserProfileModal.module__noteTextareaBase___NUpVM0",
  "jd": "UserProfileModal.module__noteTextareaEditing___NUpVM0",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___NUpVM0",
  "bs": "UserProfileModal.module__profileContent___NUpVM0",
  "EM": "UserProfileModal.module__profileContentHeader___NUpVM0",
  "cI": "UserProfileModal.module__bannerContainer___NUpVM0",
  "HG": "UserProfileModal.module__bannerMask___NUpVM0",
  "_e": "UserProfileModal.module__bannerImage___NUpVM0",
  "N1": "UserProfileModal.module__headerContainer___NUpVM0",
  "H": "UserProfileModal.module__avatarContainer___NUpVM0",
  "fc": "UserProfileModal.module__actionButtonsContainer___NUpVM0",
  "hQ": "UserProfileModal.module__contentContainer___NUpVM0",
  "sq": "UserProfileModal.module__profileContentWrapper___NUpVM0",
  "zL": "UserProfileModal.module__scrollerFullHeight___NUpVM0",
  "jT": "UserProfileModal.module__modalContainer___NUpVM0",
  "uu": "UserProfileModal.module__actionButtons___NUpVM0",
  "iA": "UserProfileModal.module__buttonIcon___NUpVM0",
  "ro": "UserProfileModal.module__menuIcon___NUpVM0",
  "WB": "UserProfileModal.module__avatarFocusRing___NUpVM0",
  "VS": "UserProfileModal.module__tabsWrapper___NUpVM0",
  "OT": "UserProfileModal.module__mutualFriendsList___NUpVM0",
  "Z8": "UserProfileModal.module__mutualSectionDivider___NUpVM0",
  "KF": "UserProfileModal.module__mutualFriendItem___NUpVM0",
  "vu": "UserProfileModal.module__active___NUpVM0",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___NUpVM0",
  "D9": "UserProfileModal.module__mutualFriendInfo___NUpVM0",
  "eV": "UserProfileModal.module__mutualFriendName___NUpVM0",
  "zD": "UserProfileModal.module__mutualFriendUsername___NUpVM0",
  "p$": "UserProfileModal.module__emptyState___NUpVM0",
  "Ny": "UserProfileModal.module__mutualGuildIcon___NUpVM0",
  "me": "UserProfileModal.module__separator___NUpVM0",
  "AI": "UserProfileModal.module__emptyStateIcon___NUpVM0",
};

module.exports = exports;
